import gql from 'graphql-tag';

export default (requestId) => gql`
  query ListSocialProvidersByRequest {
    listSocialProvidersByRequest(
      requestId: "${requestId}"
    ) {
        id,
        requestId,
        provider,
        name,
        email,
        photoUrl,
        createdAt
    }
  }
`;
